var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNecrons = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 511.485,
  height: 800,
  viewBox: "0 0 511.485 800"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.83074 0 0 .83074 -159.502 -14.953)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 499.8,
  cy: 387.4,
  r: 86.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.2 18H381.4L192 324.3 354.6 981h290.5l162.6-656.7ZM697 562.8l-36.8 36.8-99.6-99.6c-11 5.9-22.9 10.3-35.5 12.8v390.9H473V512.4c-12.1-2.6-23.6-6.9-34.2-12.7L339 599.6l-36.8-36.8L399 466c-12-15.3-20.5-33.5-24.5-53.3H274.1v-52.1h100.7c10.5-49.1 49.1-87.7 98.2-98.2v-42c-57.7-12.3-101-63.6-101-125h41c0 48 38.9 86.8 86.8 86.8s86.8-38.9 86.8-86.8h41c0 62-44.1 113.6-102.6 125.4V262c49.8 10 89.2 48.9 99.8 98.5h105.5v52.1H625.2c-4 19.9-12.6 38.2-24.7 53.6z"
}))));
export default SvgNecrons;